import axios from 'axios'
import type {
  ICustomerSavingsRecord,
  ICustomerSavingsCreationPayload,
  ICustomerSavingsUpdatePayload,
} from '@/types/cpm'
import type { ICustomerSavingsFilters } from '@/types/cpm/filters'
import type { IPage } from '@/types/shared/pagination'

export const getCustomerSavings = async (filters: ICustomerSavingsFilters): Promise<IPage<ICustomerSavingsRecord>> => {
  const response = await axios.get(import.meta.env.VITE_APP_CPM_CUSTOMER_SAVINGS_ENDPOINT, {
    params: filters,
  })
  return response.data
}

export const createCustomerSavings = async (
  payload: ICustomerSavingsCreationPayload
): Promise<ICustomerSavingsRecord> => {
  const response = await axios.post(import.meta.env.VITE_APP_CPM_CUSTOMER_SAVINGS_ENDPOINT, payload)
  return response.data
}

export const updateCustomerSavings = async (
  id: number,
  payload: ICustomerSavingsUpdatePayload
): Promise<ICustomerSavingsRecord> => {
  const response = await axios.patch(`${import.meta.env.VITE_APP_CPM_CUSTOMER_SAVINGS_ENDPOINT}/${id}`, payload)
  return response.data
}

export const deleteCustomerSavings = async (id: number): Promise<void> => {
  await axios.delete(`${import.meta.env.VITE_APP_CPM_CUSTOMER_SAVINGS_ENDPOINT}/${id}`)
}
